<template>
  <div class="Compass">
    <div class="Compass_wrapper">
      <!-- <div class="Compass_angle" :class="{ 'Compass_angle_good': goodAngle }">{{ Math.round(angle) }}°</div> -->
      <img class="Compass_base" src="/assets/images/compass.svg" />
      <img class="Compass_arrow" src="/assets/images/compass-arrow.svg" :style="{ transform: 'translate(-50%, -50%) rotate(' + angle + 'deg)' }" />
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    data() {
      return {
        goodAngle: false
      }
    },
    computed: {
      ...mapState([
        'angle'
      ])
    },
    watch: {
      angle()
      {
        if(this.angle <= -83 && this.angle >= -114)
        {
          this.goodAngle = true
        }else{
          this.goodAngle = false
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
.Compass

  position absolute 
  bottom 40px
  left 40px
  z-index 10
  width 200px

  @media $small

    width 120px
    left 20px
    bottom 20px

  &_wrapper

    display table
    position relative
    width 100%

  &_angle

    text-align center
    position absolute
    color white
    top -25px
    left 3px
    width 100%

    // &_good

    //   color $red

  &_base

    width 100%
    display block

  &_arrow

    position absolute
    transform translate(-50%,-50%)
    top 50%
    left 50%
    width 10%
</style>